import React from 'react';
import * as Icons from '@ant-design/icons';
import {
  Steps,
  Breadcrumb,
  Layout,
  notification,
  Modal,
  Button,
} from 'antd/lib';
import { graphql, compose, withApollo } from 'react-apollo';
import _ from 'lodash';
import { errorService } from '../../../graphql/utils/utils';

import { verPdf } from '../../common/funciones/verPdf';
import SelectorModelo from '../formularios/SelectorModelo';
import Generador from '../../generador/Generador';
import CKEditor from '../../editor/Example';
import { imprimir } from '../../common/funciones/imprimir';
import Loading from '../../common/Loading';

import ModalBuscarAntecedentes from '../Antecedentes/ModalBuscarAntecedentes';
import FormArregloExtrajudicial from './FormArregloExtrajudicial';

import obtenerNumeroTalonario from '../../../graphql/mutations/editor/obtenerNumeroTalonario.graphql';
import BuscarYCrearPersona from '../../procesos/BuscarYCrearPersona';
import buscarAntecedentes from '../../../graphql/querys/contravenciones/buscarAntecedentes.graphql';
import antecedentes from '../../../graphql/querys/contravenciones/antecedentes.graphql';
import getUsuario from '../../../graphql/querys/auth/getUsuario.graphql';
import insertarArreglo_Extrajudicial from '../../../graphql/mutations/arreglosExtrajudiciales/insertarArreglo_Extrajudicial.graphql';
import crearArregloExtrajudicial from '../../../graphql/mutations/arreglosExtrajudiciales/crearArregloExtrajudicial.graphql';
import confirmarAcuerdoExtrajudicial from '../../../graphql/mutations/arreglosExtrajudiciales/confirmarAcuerdoExtrajudicial.graphql';
import insertDetalleVenta from '../../../graphql/mutations/venta/insertDetalleVenta.graphql';
import insertVenta from '../../../graphql/mutations/venta/insertVenta.graphql';
import agregarDocumento from '../../../graphql/mutations/arreglosExtrajudiciales/agregarDocumento.graphql';
import insertDocumento from '../../../graphql/mutations/common/insertDocumento.graphql';

const confirm = Modal.confirm;
const estiloContent = {
  marginTop: 16,
  border: '1px dashed #e9e9e9',
  borderRadius: 6,
  backgroundColor: '#fafafa',
  paddingTop: 20,
};

@compose(
  graphql(insertDetalleVenta, {
    name: 'insertDetalleVenta',
  }),
  graphql(insertVenta, {
    name: 'insertVenta',
  }),
  graphql(insertarArreglo_Extrajudicial, {
    name: 'insertarArreglo_Extrajudicial',
  }),
  graphql(crearArregloExtrajudicial, {
    name: 'crearArregloExtrajudicial',
  }),
  graphql(confirmarAcuerdoExtrajudicial, {
    name: 'confirmarAcuerdoExtrajudicial',
  }),
  graphql(agregarDocumento, {
    name: 'agregarDocumento',
  }),
  graphql(insertDocumento, {
    name: 'insertDocumento',
  }),
  graphql(getUsuario)
)
class CrearArregloExtrajudicial extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      requirente: {},
      requeridos: [],
      motivo: '',
      numero: null,
      confirmado: false,
      mostrarModalAntecedentes: false,
      expedientesAntecedentesExternos: [],
      expedientesAntecedentes: [],
      arregloExtrajudicial: {},
      nota: {},
      step: 0,
      requeridoDNI: true,
    };
  }

  guardarRequirente = persona => {
    // console.log('Guardar requirente: ', persona);
    delete persona.__typename;
    delete persona.fecha_ultimo_cambio;

    this.setState(
      {
        requirente: {
          ...this.state.requirente,
          ...persona,
        },
      },
      function() {
        this.siguientePaso();
      }
    );
  };

  guardarRequeridos = persona => {
    // console.log('Guardar requeridos: ', persona);
    let requeridos = this.state.requeridos;
    requeridos.push(persona._id);
    this.setState(
      {
        requeridos: requeridos,
      },
      function() {
        let yo = this;
        confirm({
          title: 'Quiere continuar cargando requeridos?',
          content: 'Si desea ir al paso siguiente, presione el boton NO.',
          okText: 'Si',
          okType: 'primary',
          cancelText: 'No',
          onOk() {
            // vuelvo a preguntar si conoce el DNI
            confirm({
              title: 'Conoce el Documento del Requerido?',
              content: 'En caso de no conocerlo, podra agregar menos datos.',
              okText: 'Si',
              okType: 'primary',
              cancelText: 'No',
              onOk() {
                yo.setState({
                  requeridoDNI: true,
                });
              },
              onCancel() {
                yo.setState({
                  requeridoDNI: false,
                });
              },
            });
          },
          onCancel() {
            //  console.log('Los requeridos quedan...', yo.state.requeridos);
            yo.siguientePaso();
          },
        });
      }
    );
  };

  buscarAntecedentes = () => {
    this.setState({
      ...this.state,
      loading: true,
    });
    this.props.client
      .query({
        query: buscarAntecedentes,
        variables: {
          tipo_doc: this.state.requirente.tipo_doc,
          num_doc: this.state.requirente.num_doc,
        },
      })
      .then(respuesta => {
        if (respuesta.data.buscarAntecedentes) {
          this.props.client
            .query({
              query: antecedentes,
              variables: {
                tipoDoc: this.state.requirente.tipo_doc,
                numDoc: this.state.requirente.num_doc,
              },
            })
            .then(res => {
              notification.info({
                message: 'Busqueda realizada con exito.',
              });
              let exp = [];
              let expedientes = respuesta.data.buscarAntecedentes;
              expedientes.forEach(element => {
                exp.push(element);
              });
              this.setState({
                expedientesAntecedentes: exp,
                expedientesAntecedentesExternos: res.data.antecedentes
                  ? res.data.antecedentes.antecedentes
                  : [],
                mostrarModalAntecedentes: true,
                loading: false,
              });
            })
            .catch(error => {
              console.log('error interno al buscar antecedentes: ', error);
              notification.error({
                message:
                  'Error al buscar los antecedentes dentro de Justicia de Paz',
              });

              this.setState({
                loading: false,
              });
            });
        } else {
          notification.error({
            message: 'No se encontraron Antecedentes',
          });
        }
      })
      .catch(err => {
        console.log('error en busqueda de antecedentes', err);
        notification.error({
          message:
            'Error al buscar los antecedentes externos a la Justicia de Paz',
        });
        this.setState({
          loading: false,
        });
      });
  };

  guardarFormulario = (datos, ventaSinStock) => {
    this.setState(
      {
        motivo: datos.motivo,
        existeVenta: datos.existeVenta,
        detalles: datos.detalles,
        datosPosnet: datos.datosPonset,
        datosMP: datos.datosMP,
        extras: datos.extras,
      },
      () => {
        this.crearArregloConVenta();
      }
    );
  };

  crearArregloConVenta = () => {
    let arregloExtrajudicial;
    let modeloDetalleVenta = { idTipo_Sello: null, cantidad: null };
    const { existeVenta, datosPosnet, detalles, extras, datosMP } = this.state;
    let venta;

    arregloExtrajudicial = {
      idRequirente: this.state.requirente._id,
      requeridos: this.state.requeridos,
      idOrganismo: this.props.data.getUsuario.organismo._id,
      motivo: this.state.motivo,
      idCreador: this.props.data.getUsuario._id,
    };

    if (existeVenta && detalles.length > 0) {
      // CREO TRAMITE CON VENTA
      let { email, enviarPorEmail, descargarRecibo } = extras;
      let detallesFiltrados = _.map(detalles, detalle => {
        let result = _.pick(detalle, _.keys(modeloDetalleVenta));
        return result;
      });

      venta = {
        idVendedor: this.props.data.getUsuario._id,
        idOrganismo: this.props.data.getUsuario.organismo._id,
        detalle: detallesFiltrados,
        datosPosnet:
          datosPosnet &&
          (datosPosnet.codigoOperacion || datosPosnet.numeroTicket)
            ? {
                codigoOperacion: datosPosnet.codigoOperacion,
                numeroTicket: datosPosnet.numeroTicket,
                cuenta: 'Tasas',
              }
            : null,
        datosMP: datosMP
          ? { numeroComprobante: datosMP.numeroComprobante }
          : null,
        datosRecibo: {
          email,
          enviarPorEmail,
          descargarRecibo,
        },
      };

      this.props
        .crearArregloExtrajudicial({
          variables: {
            arregloExtrajudicial: arregloExtrajudicial,
            venta: venta,
          },
        })
        .then(respuesta => {
          notification.success({
            message: 'Nuevo Acuerdo extrajudicial',
            description:
              'Se ha registrado con exito el Acuerdo extrajudicial y la Venta',
          });

          if (
            descargarRecibo &&
            respuesta.data.crearArregloExtrajudicial &&
            respuesta.data.crearArregloExtrajudicial.venta &&
            respuesta.data.crearArregloExtrajudicial.venta.recibo64
          ) {
            verPdf(
              respuesta.data.crearArregloExtrajudicial.venta.recibo64,
              `Recibo_Num_${respuesta.data.crearArregloExtrajudicial.venta.id}`
            );
          }

          this.setState(
            {
              ...this.state,
              arregloExtrajudicial: {
                ...this.state.arregloExtrajudicial,
                ...respuesta.data.crearArregloExtrajudicial,
              },
              guardado: true,
              loading: false,
            },
            () => {
              this.siguientePaso();
            }
          );
        })
        .catch(error => {
          console.log('Excepcion!!');
          console.log(error);
          this.setState({
            loading: false,
          });

          Modal.error({
            title: 'Error en la creacion del Acuerdo Extrajudicial',
            content:
              'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
          });
        });
    } else {
      // CREO TRAMITE SIN VENTA
      let yo = this;
      confirm({
        title: 'Está seguro de que desea crear el acuerdo SIN VENTA?',
        content: 'No podrá hacer cambios sobre este tramite',
        onOk: () => {
          yo.setState({
            loading: true,
          });
          yo.props
            .crearArregloExtrajudicial({
              variables: {
                arregloExtrajudicial: arregloExtrajudicial,
              },
            })
            .then(respuesta => {
              notification.success({
                message: 'Nuevo Acuerdo extrajudicial',
                description:
                  'Se ha registrado con exito el Acuerdo extrajudicial sin venta',
              });

              yo.setState(
                {
                  ...yo.state,
                  arregloExtrajudicial: {
                    ...yo.state.arregloExtrajudicial,
                    ...respuesta.data.crearArregloExtrajudicial,
                  },
                  guardado: true,
                  loading: false,
                },
                () => {
                  yo.siguientePaso();
                }
              );
            })
            .catch(error => {
              console.log('Excepcion!!');
              console.log(error);
              yo.setState({
                loading: false,
              });

              Modal.error({
                title: 'Error en la creacion del Acuerdo Extrajudicial',
                content:
                  'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
              });
            });
        },
        onCancel() {
          console.log('Cancel');
          yo.setState({
            loading: false,
          });
        },
      });
    }
  };

  notaSeleccionada = idNota => {
    // console.log('nota change ==>', idNota);
    this.setState({
      ...this.state,
      nota: {
        idModeloNota: idNota,
      },
    });
  };

  ModeloNotaElegido = idNota => {
    // console.log('onSubmit nota elegida ===>', idNota);

    this.setState(
      {
        ...this.state,
        nota: {
          ...this.state.nota,
          idModeloNota: idNota.modelo,
        },
        loading: true,
      },
      () => {
        this.props.client
          .mutate({
            mutation: obtenerNumeroTalonario,
            variables: {
              idModeloNota: this.state.nota.idModeloNota,
            },
          })
          .then(respuesta => {
            // console.log('numeroTalonario Res ===>', respuesta);
            if (respuesta.data.obtenerNumeroTalonario == -1) {
              notification.warning({
                message: 'Talonario no configurado',
                description:
                  'El modelo de nota no tiene configurado el talonario a usar',
              });
            }

            this.setState({
              ...this.state,
              numero: respuesta.data.obtenerNumeroTalonario
                ? respuesta.data.obtenerNumeroTalonario
                : 0,
              loading: false,
            });

            this.siguientePaso();
          })
          .catch(err => {
            console.log('ERROR a la hora de obtener el numero del  talonario');
            console.log(err);
            this.setState({
              loading: false,
            });
          });
      }
    );
  };

  obtenerDatosGeneracion = () => {
    //Este metodo es el encargado de, dependiendo lo necesario, de generar un unico objeto que
    //Será utilizado para pasarselo al componente generador como datos de entradas.

    let textoOperacion = `Este tramite fue exento del pago de tasa de justicia - Ley N° 1971 Art. 3 -`;
    if (
      this.state.arregloExtrajudicial &&
      this.state.arregloExtrajudicial.venta
    ) {
      let venta = this.state.arregloExtrajudicial.venta;
      textoOperacion = `Por este trámite se abono la suma de $${venta.importe} mediante el uso de ${venta.tipoPago}, en concepto de pago de tasa de justicia - Ley N° 1971 Art. 3 -`;
    }

    let datos = {
      numero: this.state.numero,
      organismo: this.state.arregloExtrajudicial.organismo,
      requirente: this.state.arregloExtrajudicial.requirente,
      motivo: this.state.arregloExtrajudicial.motivo,
      textoOperacion: textoOperacion,
    };

    this.state.arregloExtrajudicial.requeridos.map(
      (elem, index) => (datos[`requerido${index + 1}`] = elem)
    );
    // console.log('LOS DATOS QUEDAN DE LA SIGUIENTE MANERA ===> ');
    console.log(datos);
    return datos;
  };

  finProcesoGeneracion = textoGenerado => {
    this.setState(
      {
        ...this.state,
        nota: {
          ...this.state.nota,
          htmlModelo: textoGenerado,
        },
      },
      function() {
        //Esta es una declaracion de una funcion sincronica, que espera a que el setState se haga para ejecutarse. Un Callback
        this.siguientePaso();
      }
    );
  };

  confirmarAcuerdoExtrajudicial = htmlFinal => {
    this.props
      .confirmarAcuerdoExtrajudicial({
        variables: {
          _id: this.state.arregloExtrajudicial._id,
          idModeloNota: this.state.nota.idModeloNota,
          numero: this.state.numero,
        },
      })
      .then(res => {
        console.log('CONFIRMADA CON EXITO =>', res);

        this.setState(
          {
            ...this.state,
            confirmado: true,
          },
          () => {
            this.onGuardarForm(htmlFinal);
          }
        );
      })
      .catch(err => {
        console.log('error al confirmar la solicitud de acuerdo extrajudicial');
        console.log(err);

        Modal.error({
          title:
            'Error en la confirmacion de la solicitud de acuerdo extrajudicial',
          content:
            'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
        });
      });
  };

  onGuardarForm = htmlFinal => {
    this.setState({ ...this.state, loading: true });
    let yo = this;

    this.props
      .insertDocumento({
        variables: {
          documento: {
            tramite: 'acuerdo_extrajudicial',
            idTramite: this.state.arregloExtrajudicial._id,
            textoHtml: htmlFinal,
            idModeloNota: this.state.nota.idModeloNota,
            allowDelete: false,
          },
        },
      })
      .then(resDocumento => {
        let idDocumento = resDocumento.data.insertDocumento._id;

        this.props
          .agregarDocumento({
            variables: {
              _id: this.state.arregloExtrajudicial._id,
              idDocumento,
            },
          })
          // eslint-disable-next-line no-unused-vars
          .then(res => {
            notification.success({
              message: 'Documento agregado al acuerdo extrajudicial',
              description:
                'El documento se agrego correctamente al arreglo extrajudicial',
            });

            yo.setState(
              {
                loading: false,
              },
              () => {
                yo.props.history.push(
                  `/tramites/acuerdosExtrajudiciales/listar`
                );
              }
            );
          })
          .catch(err => {
            console.log(
              'Error a la hora de agregar el documento al arreglo extrajudicial'
            );
            console.log(err);
          });
      })
      .catch(err => {
        console.log('Ocurrio un error a la hora de insertar el documento...');
        console.log(err);
      });
  };

  onImprimir = htmlFinal => {
    imprimir(htmlFinal);
    this.confirmarAcuerdoExtrajudicial(htmlFinal);
  };

  onCancel = () => {
    Modal.confirm({
      title: '¿Estás seguro de cancelar el trámite?',
      content:
        'Al cancelar el trámite, se perderán los datos ingresados. ¿Deseas continuar?',
      okText: 'Sí',
      cancelText: 'No',
      onOk: () => {
        this.setState(
          {
            arregloExtrajudicial: {},
            requirente: {},
            requeridos: [],
            expedientesAntecedentesExternos: [],
            expedientesAntecedentes: [],
            motivo: '',
            datosMP: undefined,
            datosPosnet: undefined,
            detalles: undefined,
            existeVenta: undefined,
            extras: undefined,
            nota: {},
            numero: undefined,
            confirmado: false,
            step: 0,
          },
          () => {
            this.props.history.push('/');
          }
        );
      },
      onCancel: () => {
        // El usuario ha cancelado la acción
      },
    });
  };

  siguientePaso = () => {
    let yo = this;

    this.setState(
      {
        ...this.state,
        step: this.state.step + 1,
      },
      () => {
        if (this.state.step == 2) {
          //Pregunto si se conoce el DNI del Requerido
          confirm({
            title: 'Conoce el Documento del Requerido?',
            content: 'En caso de no conocerlo, podra agregar menos datos.',
            okText: 'Si',
            okType: 'primary',
            cancelText: 'No',
            onOk() {
              yo.setState({
                requeridoDNI: true,
              });
            },
            onCancel() {
              yo.setState({
                requeridoDNI: false,
              });
            },
          });
        }
      }
    );
  };

  pasoAnterior = () => {
    this.setState({
      ...this.state,
      step: this.state.step - 1,
    });
  };

  ocultarModalAntecendetes = () => {
    this.setState({
      mostrarModalAntecedentes: false,
    });
  };

  render() {
    if (this.state.loading) {
      return <Loading />;
    }

    const { Step } = Steps;
    const { data } = this.props;
    const usuario = data ? data.getUsuario : {};
    let { step } = this.state;

    return (
      <div>
        <Breadcrumb
          style={{
            margin: '12px 0',
          }}
        >
          <Breadcrumb.Item>Acuerdo Extrajudicial</Breadcrumb.Item>
          <Breadcrumb.Item>Nuevo</Breadcrumb.Item>
        </Breadcrumb>
        <Layout
          style={{
            background: '#fff',
            padding: 24,
            minHeight: '80vh',
          }}
        >
          <h2 style={{ marginBottom: 10, textAlign: 'center' }}>
            <Icons.FileTextOutlined /> Nuevo Acuerdo Extrajudicial
          </h2>
          <br />
          <Steps size="small" className="stepsFormularios" current={step}>
            <Step title="Buscar Requirente" />
            <Step title="Antecedentes" />
            <Step title="Buscar Requerido" />
            <Step title="Formulario" />
            <Step title="Modelo Nota" />
            <Step title="Generacion de Nota" />
            <Step title="Editar e Imprimir" />
          </Steps>
          <div style={estiloContent}>
            {step === 0 && (
              <BuscarYCrearPersona obtenerPersona={this.guardarRequirente} />
            )}
            {step === 1 && (
              <div
                style={{
                  minHeight: '60vh',
                }}
              >
                <h2
                  style={{
                    marginTop: 60,
                    marginBottom: 35,
                    textAlign: 'center',
                  }}
                >
                  Buscar antecedentes del Requirente
                </h2>
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                  <Button
                    style={{ marginRight: 20 }}
                    type="primary"
                    onClick={this.buscarAntecedentes}
                  >
                    Buscar
                  </Button>

                  <Button onClick={() => this.siguientePaso()}>
                    Continuar
                  </Button>
                </div>
                <ModalBuscarAntecedentes
                  mostrarModalAntecedentes={this.state.mostrarModalAntecedentes}
                  ocultarModalAntecendetes={this.ocultarModalAntecendetes}
                  expedientes={this.state.expedientesAntecedentes}
                  expedientesExternos={
                    this.state.expedientesAntecedentesExternos
                  }
                  persona={this.state.requirente}
                />
              </div>
            )}
            {step === 2 && (
              <BuscarYCrearPersona
                obtenerPersona={this.guardarRequeridos}
                requeridoDNI={this.state.requeridoDNI}
              />
            )}
            {step === 3 && (
              <>
                <FormArregloExtrajudicial
                  organismo={this.props.data.getUsuario.organismo}
                  className="formularios"
                  onSubmit={this.guardarFormulario}
                  onAnterior={this.pasoAnterior}
                />
              </>
            )}
            {step === 4 && (
              <SelectorModelo
                handleChange={this.notaSeleccionada}
                onSubmit={this.ModeloNotaElegido}
              />
            )}
            {step === 5 && (
              <Generador
                id={this.state.nota.idModeloNota}
                datos={this.obtenerDatosGeneracion()}
                mostrarEditor={this.finProcesoGeneracion}
              />
            )}
            {step === 6 && (
              <CKEditor
                modelo_nota={this.state.nota}
                onImprimir={this.onImprimir}
                onGuardar={this.confirmarAcuerdoExtrajudicial}
                onCancel={this.onCancel}
                accion="visualizar"
              />
            )}
          </div>
        </Layout>
      </div>
    );
  }
}

export default withApollo(CrearArregloExtrajudicial);
